import axios from 'axios';
import { from } from 'rxjs';

import type { FilterBarFilter, SortState } from './purchase-orders.types';
import type { Observable } from 'rxjs';

type PurchaseOrderExportRequest = {
  Filter: {
    Filter: {
      CollectionFilters: FilterBarFilter[];
    } | null;
    OrderBy: string | null;
    Direction: 'Ascending' | 'Descending' | null;
  };
  PurchaseOrderIds: number[] | null;
};

export const exportPurchaseOrdersAsync = (
  appliedFilters: FilterBarFilter[],
  sortState: SortState,
  purchaseOrderIds: string[] | null,
): Observable<string> => {
  const requestBody: PurchaseOrderExportRequest = {
    Filter: {
      Filter:
        appliedFilters.length > 0
          ? {
              CollectionFilters: appliedFilters,
            }
          : null,
      OrderBy: sortState.orderBy,
      Direction: sortState.direction,
    },
    PurchaseOrderIds: purchaseOrderIds ? purchaseOrderIds.map((id) => parseInt(id, 10)) : null,
  };

  const getAndTransform = axios.post<string>('/purchaseOrders/export', requestBody).then((response) => response.data);

  return from(getAndTransform);
};
